import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BuisnessPromotion, AssetInfo } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-add-business-post',
  templateUrl: './add-business-post.component.html',
  styleUrls: ['./add-business-post.component.scss']
})
export class AddBusinessPostComponent implements OnInit, OnDestroy {
  public businessPostData:any = {
    postType: 2
  };
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone,
    private ls:LoaderServiceService,
    private route:ActivatedRoute,
    private activemodal: MatDialogRef<AddBusinessPostComponent>

  ) {}

removeAsset(index: any) {
    console.log(index);
    if(this.inputele){
      this.inputele.value = ''

    }
    this.assetList.splice(index, 1);
  }
  entityhash:any = ''
  photolimit:any = sessionStorage.getItem(SM_CONSTANTS.BUSINESS_POST_IMAGE_LIMIT)
  videolimit:any = sessionStorage.getItem(SM_CONSTANTS.BUSINESS_POST_VIDEO_LIMIT)
  ngOnInit(): void {
      let data: any = {}
       console.log('parentdata', this.parentData);

    Object.assign(data, this.parentData.data);
    console.log(data);
    if (this.parentData?.private_hash_id) {
      if(data.assetInfo){
        data.assetInfo.map((v: any, i: any) => {
          this.assetList.push({
            url: v.imgUrl,
            thumbnail: v.imageThumbUrl,
            assetType: v.asset_type
          });
        });

      }

      this.businessPostData.postTitle = data.postTitle;
      this.businessPostData.description = data.postDesc;
      this.businessPostData.externalLink = data.externalLink;
      this.businessPostData.postType = data.postType;
      // this.businessPostData.targetaddress = data.external_link;
      this.editMode = true;
    }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        setTimeout(() => {
          
          this._ngZone.run(() => {
            this.assetList.push({
              assetName: this.fileName,
              url: res.result?.url,
              thumbnail: res.result?.thumbnail,
              assetType: this.assetType
            });
            this.inputele.value = ''
            this.loader = false;
          });
          // this.businessPostData.imgUrl = res.result?.url;
          console.log(this.assetList);
          
        }, 3000);
      }
    if (res.responseType === SM_CONSTANTS.RESULT_API_UPDATE_POST_INFO) {
        if (res.result) {
          this.activemodal.close({msg:'success'})
        }
      }
    });

    this.route.queryParams.subscribe(data => {
      if(data){
        this.entityhash = data.entityHash
      }
    })
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

 onPost() {
        if(!this.editMode){
          this.assetList.map((d, i) => {
            if (d.thumbnail) {
              this._assetInfo.push({
                thumbImgUrl: d.thumbnail,
                imgUrl: d.url,
                "userType": 1,
                "assetType": d.assetType
              });
            }
          });
      
          let obj = {
            "postInfo": {
              "postType": this.businessPostData.postType,
              "postTitle": this.businessPostData.postTitle,
              "description": this.businessPostData.description,
              "imgUrl": this._assetInfo.length > 0 ? this._assetInfo[0].imgUrl : null,
              "searchType": 5,
              "externalLink": this.businessPostData.externalLink ??  null,
              "location": localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_ADDRESS),
              "location_string": localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_ADDRESS),
              "imgThumbUrl": this._assetInfo.length > 0 ? this._assetInfo[0].thumbImgUrl : null,
              "assetInfo": this._assetInfo
            }
          }
      
          Object.keys(obj.postInfo).forEach(key => {
            if ((obj.postInfo as any)[key] === null) {
              delete (obj.postInfo as any)[key];
            }
          });
      
          console.log(obj);
          this.ls.showLoader = true
          this._apiService.updatePostInfo(obj,this.entityhash)
        
        }
        else if(this.editMode){

       this.assetList.map((d, i) => {
      if (d.thumbnail) {
        this._assetInfo.push({
          thumbImgUrl: d.thumbnail,
          imgUrl: d.url,
          "userType": 3,
          "assetType": d.assetType
        });
      }
    });

    let obj = {
      "postInfo": {
        "hash_id" : this.parentData.private_hash_id,
        "postType": this.businessPostData.postType,
        "postTitle": this.businessPostData.postTitle,
        "description": this.businessPostData.description,
        "imgUrl": this._assetInfo.length > 0 ? this._assetInfo[0].imgUrl : null,
        "searchType": 5,
        "externalLink": this.businessPostData.externalLink ??  null,
        "imgThumbUrl": this._assetInfo.length > 0 ? this._assetInfo[0].thumbImgUrl : null,
        "assetInfo": this._assetInfo,
        "location": localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_ADDRESS),
        "location_string": localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_ADDRESS),
      }
    }

    Object.keys(obj.postInfo).forEach(key => {
      if ((obj.postInfo as any)[key] === null) {
        delete (obj.postInfo as any)[key];
      }
    });

    console.log(obj);
    this.ls.showLoader = true
    this._apiService.updatePostInfo(obj,this.entityhash)
  }
  
  }
  assetType: number = 0
  inputele:any
 onUploadImage(event: any) {
    this.inputele = event.target;
    this.assetType = 0
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

     const originalFile = event.target.files[0];
    let fileName = originalFile.name;

    if (fileName.includes(' ')) {
      fileName = fileName.replace(/\s+/g, '_');
    }

    const sanitizedFile = new File([originalFile], fileName, { type: originalFile.type });

    console.log(this.fileName);
    let sizeinKb = +event.target.files[0].size / 1000;
 
    this.loader = true;
    let formData: FormData = new FormData();
    formData.append('recfile', sanitizedFile);
    const mimeType = event.target.files[0].type;
    if (mimeType.startsWith('image/')) {
      console.log('image');
      if (sizeinKb > 5120) {
        this.loader = false;
        this.inputele.value = ''
        this._snackBar.open(
          'Image size should not exceed more then 3 mb',
          'Ok',{
            duration: 3000,
          }
        );
        return;
      }
      if(this.countAssetsByType(1) < this.photolimit){
        this.assetType = 1
        this._apiService.uploadAssets(formData, 1);
        return;

      }
      else{
        this.loader = false;
        this.inputele.value = ''
        this._snackBar.open(
          'Maximum ' + this.photolimit + ' images allowed per business post.',
          'Ok',{
            duration: 3000,
          }
        );
        return;
      }
    }
    if (mimeType.startsWith('video/')) {
      console.log('Video');
      if(sizeinKb > 15360){
        this.inputele.value = ''
        this.loader = false;
        this._snackBar.open(
          'Video size should not exceed more then 5 mb',
          'Ok',{
            duration: 3000,
          }
        );
        return;

      }
      if(this.countAssetsByType(2) < this.videolimit){
        this.assetType = 2
        this._apiService.uploadAssets(formData, 3);
          return;

      }
      else{
        this.loader = false;
        this.inputele.value = ''
        this._snackBar.open(
          'Maximum ' + this.videolimit + ' videos allowed per business post.',
          'Ok',{
            duration: 3000,
          }
        );
        return;
      }

    }

    this.loader = false;
    this.inputele.value = ''
    this._snackBar.open('File format not supported', 'Ok');

    // this._apiService.uploadAssets(formData, 1);
  }

  locationAutoComplete(event: any) {
    console.log('location', event.place.address_components);
    // administrative_area_level_1 = state
    // locality = city
    // country = country
    event.place.address_components?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === 'administrative_area_level_1') {
        this.businessPostData.targetState = data?.long_name;
      } else if (type === 'locality') {
        this.businessPostData.targetCity = data.long_name;
      } else if (type === 'country') {
        this.businessPostData.targetCountry = data.long_name;
      }
    });
  }

  countAssetsByType(assetType: number): number {
    return this.assetList.filter(asset => asset.assetType === assetType).length;
}
}
